import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}

export default function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background-100 px-4 py-10">
      {/* 배경 장식 */}
      <div className="pointer-events-none absolute inset-0 opacity-70">
        <div className="absolute -left-24 top-[-80px] h-[420px] w-[420px] rounded-full bg-primary-100/60 blur-3xl" />
        <div className="absolute bottom-[-120px] right-[-60px] h-[460px] w-[460px] rounded-full bg-accent-100/60 blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-[420px]">
        <Link to="/" className="mb-6 flex items-center justify-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-pencil-ruler-2-line text-xl"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">오답노트 메이커</span>
        </Link>

        <div className="rounded-lg border border-background-200 bg-white p-7">
          <h1 className="font-heading text-xl font-bold text-foreground-950">{title}</h1>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{subtitle}</p>
          <div className="mt-6">{children}</div>
        </div>

        {footer && <div className="mt-5 text-center text-sm text-foreground-600">{footer}</div>}
      </div>
    </div>
  );
}